import React from 'react'


const content = `
  <h1>
    Sidan kunde inte hittas
  </h1>
  <p>
    Söker du något särskilt? Vår kundservice finns tillgänglig på telefon alla dagar i
    veckan, för att ge personlig support.
  </p>
  <p>
    <a href="/">
    <br>
      « Gå till startsidan
    </a>
  </p>`

const NotFoundPage: React.FC<{}> = () => {
  console.log('at NotFoundPage render')
  return (
    <>
      sidan kan inte hittas.
    </>
  )
}

export default NotFoundPage
